import { cn } from "@/lib/cn";
import { SebasMark } from "./SebasMark";

/** Mark + wordmark lock-up for headers and the sign-in screen. */
export function SebasLogo({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2 text-ink", className)}>
      <SebasMark className="h-7 w-7 shrink-0" title="Sebas" />
      {showWordmark ? (
        <span className="font-display text-[1.35rem] font-semibold tracking-tight">Sebas</span>
      ) : null}
    </span>
  );
}
